import { Link } from "react-router-dom";

export default function MemberPolicy() {
  const POLICY_TITLE = [
    "개인정보 수집 및 방법",
    "개인정보 이용",
    "개인정보 제공",
    "개인정보 처리의 위탁",
    "개인정보 파기",
    "자동 수집 장치의 설치/운영",
    "개인정보 보호책임자 안내",
    "개인정보처리방침 변경"
  ];
  return (
    <div className="member-policy-page">
      <header className="header member-policy-header">
        <div className="container">
          <Link to="/" className="header-logo">
            WHISPER
          </Link>
          <h2>개인정보처리방침</h2>
          <Link to="/" className="btn btn-outline-primary btn-sm">
            홈으로 이동
          </Link>
        </div>
      </header>

      <main className="member-policy-body p-4 p-lg-5">
        <div className="member-policy-content">
        <h2 style={{textAlign: "center", marginBottom: "2rem"}}>개인정보처리방침</h2>

      <p>
        주식회사 구루위스퍼(이하 "회사")는 이용자의 '동의를 기반으로 개인정보를 수집・이용 및 제공'하고 있으며, '이용자의 권리(개인정보 자기결정권)를 적극적으로 보장'합니다. 회사는 정보통신서비스제공자가 준수하여야 하는 대한민국의 관련 법령 및 개인정보 규정과 가이드라인을 준수하고 있습니다.<br />
        본 개인정보방침은 회사에 제공한 이용자의 개인정보가 보호 받을 수 있도록 회사가 준수해야 할 지침을 의미합니다.<br />
        본 개인정보처리방침은 회사가 제공하는 회원계정 기반의 서비스(이하'서비스')에 적용됩니다.<br />
        본 개인정보처리 방침은 정부의 법률 및 지침 변경이나 회사의 내부 방침 변경 등으로 인하여 수시로 변경될 수 있으며, 개정된 사항은 개인정보 처리 방침을 시행하기 최소 7일 전에 쉽게 알아볼 수 있도록 회사가 제공하는 서비스 페이지에 공지하도록 하겠습니다.<br />
        회사의 개인정보처리방침은 아래와 같은 내용을 담고 있습니다.<br />
      </p>
      <div className="mb-4">
        <p>
          {POLICY_TITLE.map((title, index)=> (
            <div>{index+1}.{title}</div>
          ))}
        </p>
      </div>

      <h3>1. 개인정보 수집 및 방법</h3>
      <p>회원 가입 시 또는 서비스 이용 과정에서 홈페이지 또는 개별 어플리케이션이나 프로그램등을 통해 아래와 같은 서비스 제공을 위해 필요한 개인정보를 수집할 수 있습니다.</p>

      <h4>1) 개인정보 수집 항목</h4>
      <p>
        [회원가입 시]<br />
        - 필수 : 이메일, 비밀번호, 이름<br />
        * 소셜 계정 간편로그인 가입 시 : 이메일, 이름, 암호화된 이용자 확인값
      </p>
      <p>
        [유료서비스 이용 시]<br />
        - 신용카드 결제 시 : 카드번호(일부), 카드사명, 휴대폰번호<br />
        - 계좌이체 시 : 예금주명, 계좌번호, 계좌은행 등, 휴대폰번호
      </p>
      <p>
        [환불처리 시]<br />
        - 계좌은행, 계좌번호, 예금주 명
      </p>

      <h4>2) 개인정보 수집 방법</h4>
      <p>개인정보를 수집하는 경우 반드시 사전에 이용자에게 해당 사실을 알리고 동의를 구하고 있으며, 아래와 같은 방법을 통해 개인정보를 수집합니다.</p>
      <p>
        ・ 회원가입 및 서비스 이용 과정에서 이용자가 개인정보 수집에 대해 동의를 하고 직접 정보를 입력하는 경우<br />
        ・ 제휴 서비스로부터 개인정보를 제공받은 경우<br />
        ・ 온/오프라인에서 진행되는 이벤트/행사 등 참여를 통한 정보 입력/전달 시
      </p>
      <p>PC웹, 모바일 웹/앱 서비스 이용 과정에서 이용자의 단말기정보, IP주소, 쿠키, 방문일시, 부정이용기록, 서비스 이용 기록 등의 정보가 자동으로 생성되어 수집될 수 있습니다.</p>

      <h3>2. 개인정보 이용</h3>
      <p>회원 가입 시 또는 서비스 이용 과정에서 홈페이지 또는 개별 어플리케이션이나 프로그램등을 통해 아래와 같은 서비스 제공을 위해 필요한 개인정보를 수집할 수 있습니다.</p>
      <p>
        ・ 회원 식별/가입의사 확인, 본인 확인, 부정이용 방지<br />
        ・ 신규 서비스 개발, 다양한 서비스 제공, 문의사항 또는 불만처리, 공지사항 전달<br />
        ・ 유료서비스 이용 시 콘텐츠 등의 전송이나 배송-요금 정산<br />
        ・ 서비스의 원활한 운영에 지장을 주는 행위(계정 도용 및 부정 이용 행위 등 포함)에 대한 방지 및 제재<br />
        ・ 인구통계학적 특성과 이용자의 관심, 기호, 성향의 추정을 통한 맞춤형 콘텐츠 추천 및 마케팅에 활용<br />
        ・ 서비스 이용 기록, 접속 빈도 및 서비스 이용에 대한 통계, 프라이버시 보호 측면의 서비스 환경 구축, 서비스 개선에 활용
      </p>

      <h3>3. 개인정보 제공</h3>
      <p>회사는 원칙적으로 이용자의 개인정보를 제3자에게 제공하지 않습니다. 다만, 다음의 경우에는 예외로 합니다.</p>
      <p>
        1. 이용자의 사전 동의를 받은 경우<br />
        2. 법령에 따라 제공이 요구되는 경우<br />
      </p>
      <h3>4. 개인정보 처리의 위탁</h3>
      <p>
        회사는 원활한 서비스 제공을 위해 다음과 같이 개인정보 처리를 위탁할 수 있습니다.
      </p>

      <h3>5. 개인정보 파기</h3>
      <p>개인정보는 수집 및 이용목적이 달성되면 지체 없이 파기합니다.</p>
      <p>전자적인 파일 형태인 경우 복구 및 재생되지 않도록 안전하게 삭제하고, 그밖에 기록물, 인쇄물, 서면 등의 경우 분쇄하거나 소각하여 파기합니다.</p>
      <p>다만, 상법, 전자상거래 등에서 소비자보호에 관한 법률 등 관계법령에 따라 일정기간 보관해야 하는 개인정보 및 해당 법령은 다음과 같습니다.</p>
      <p>
        <h4>1) 계약 또는 청약철회 등에 관한 기록</h4>
        ・근거법령 : 전자상거래 등에서의 소비자보호에 관한 법률<br />
        ・보존기간 : 5년
      </p>
      <p>
        <h4>2) 대금결제 및 재화 등의 공급에 관한 기록</h4>
        ・근거법령 : 전자상거래 등에서의 소비자보호에 관한 법률<br />
        ・보존기간 : 5년
      </p>
      <p>
        <h4>3) 표시/광고에 관한 기록</h4>
        ・근거법령 : 전자상거래 등에서의 소비자보호에 관한 법률<br />
        ・보존기간 : 6개월
      </p>
      <p>
        <h4>4) 소비자의 불만 또는 분쟁처리에 관한 기록</h4>
        ・근거법령 : 전자상거래 등에서의 소비자보호에 관한 법률<br />
        ・보존기간 : 3년
      </p>
      <p>
        <h4>5) 서비스 방문 기록</h4>
        ・근거법령 : 통신비밀보호법<br />
        ・보존기간 : 3개월
      </p>
      
      <h3>6. 개인정보의 자동 수집 장치의 설치/운영 안내</h3>
      <p>쿠키를 설치, 운영하고 있고 이용자는 이를 거부할 수 있습니다.</p>
      <p>쿠키는 이용자에게 보다 빠르고 편리한 웹사이트 사용을 지원하고 맞춤형 서비스를 제공하기 위해 '쿠키'가 사용됩니다.</p>
      <p>쿠키(Cookie)는 웹사이트를 운영하는데 이용되는 서버가 이용자의 디바이스에 전송 저장되는 작은 텍스트 파일입니다. 이용자가 웹사이트에 방문할 경우 이용자의 디바이스에 저장되어 있는 쿠키의 내용을 읽어 이용자의 환경설정을 유지하고 맞춤화된 서비스를 제공하게 됩니다. 쿠키는 이용자가 웹 사이트를 방문할 때, 웹 사이트 사용을 설정한대로 접속하고 편리하게 사용할 수 있도록 돕습니다. 또한, 이용자의 웹사이트 방문 기록, 이용 형태를 통해서 최적화된 광고 등 맞춤형 정보를 제공하기 위해 활용됩니다.</p>
      <p>이용자는 쿠키 설치에 대한 선택권을 가지고 있습니다. 웹 브라우저에서 옵션을 설정함으로써 모든 쿠키를 허용하거나, 모든 쿠키의 저장을 거부할 수도 있습니다. 다만, 쿠키 설치를 거부할 경우 웹 사용이 불편해지며, 로그인이 필요한 일부 서비스 이용에 어려움이 있을 수 있습니다.</p>
      <p>
      설정 변경 방법의 예<br />
        ・ Internet Explorer의 경우 : 웹 브라우저 상단의 도구 메뉴 &gt; 인터넷 옵션 &gt; 개인정보 &gt; 설정<br />
        ・ Chrome의 경우 : 웹 브라우저 우측의 설정 메뉴 &gt; 개인정보 및 보안 &gt; 쿠키
      </p>

      <h3>7. 개인정보 보호책임자 안내</h3>
      <p>서비스를 이용하면서 발생하는 모든 개인정보보호 관련 문의, 불만, 조언이나 기타 사항은 개인정보 보호책임자 및 담당부서로 연락해 주시기 바랍니다.</p>
      <p>
        <h4>개인정보 보호책임자</h4>
        ・ 책임자 : 임준성<br />
        ・ 문의 : junsung.lim@guruwhisper.com
      </p>
      <p>기타 개인정보침해에 대한 신고나 상담이 필요하신 경우, 아래 기관에 문의하시기 바랍니다.</p>
      <p>
        ・ 개인정보침해신고센터 (privacy.kisa.or.kr / 국번없이 118)<br />
        ・ 대검찰청 사이버범죄수사단 (www.spo.go.kr / 02-3480-3571)<br />
        ・ 경찰청 사이버안전국 (cyberbureau.police.go.kr / 국번없이 182)
      </p>

      <h3>8. 개인정보처리방침의 변경</h3>
      <p>개인정보 처리방침은 시행일로부터 적용됩니다. 본 개인정보처리방침은 법령 또는 회사 정책 변경에 따라 변경될 수 있으며, 변경 시 서비스 내 공지를 통해 안내합니다.</p>
      <p>
        공고일자: 2026년 03월 17일<br />
        시행일자: 2026년 03월 17일
      </p>
        </div>
      </main>
      </div>
  );
}
